import React from 'react';
import { Button, Icon, Form, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { fetchAcademicYears, fetchFaculties, fetchEmployeeTypes } from '../Lookups/util';
import WorkloadReport from './WorkloadReport';
import EmployeesByType from './EmployeesByType';
import EmployeesByAcademicTytle from './EmployeesByAcademicTytle';
import EmployeesByTypeAndGender from './EmployeesByTypeAndGender';
import EmployeesByTypeAndPosition from './EmployeesByTypeAndPosition';
import EmployeesByTypePositionAndAverageYear from './EmployeesByTypePositionAndAverageYear';
import AssociateEmployeesByTypeAndPosition from './AssociateEmployeesByTypeAndPosition';
import EmployeesWithOUEInfo from './EmployeesWithOUEInfo';
import EmployeesWithOUPositionInfo from './EmployeesWithOUPositionInfo';
import EmployeesGenderAndAgeByPosition from './EmployeesGenderAndAgeByPosition';
import EmployeesGenderAndAgeByEducationLevel from './EmployeesGenderAndAgeByEducationLevel';
import EmployeesByTypeAndAcademicYear from './EmployeesByTypeAndAcademicYear';

const reports = [
    {
        text: 'Nastavno opterećenje',
        key: 1,
        value: 1
    },
    // {
    //     text: 'Nastavno opterećenje za organizacionu jedinicu',
    //     key: 2,
    //     value: 2
    // },
    {
        text: 'Broj zaposlenika po tipu zaposlenja',
        key: 3,
        value: 3
    },
    {
        text: 'Broj zaposlenika po akademskoj tituli',
        key: 4,
        value: 4
    },
    {
        text: 'Broj zaposlenika po spolu (po tipu zaposlenja)',
        key: 5,
        value: 5
    },
    {
        text: 'Broj zaposlenika po pozicijama (po tipu zaposlenja)',
        key: 6,
        value: 6
    },
    {
        text: 'Prosjek godina po pozicijama',
        key: 7,
        value: 7
    },
    {
        text: 'Broj angažovanog osoblja po pozicijama (izvan UNSA)',
        key: 8,
        value: 8
    },
    {
        text: 'Podaci o zaposlenicima sa njihovim angažmanima na organizacionim jedinicama',
        key: 9,
        value: 9
    },
    {
        text: 'Podaci o zaposlenicima sa njihovim pozicijama na matičnoj organizacionoj jedinici',
        key: 10,
        value: 10
    },
    {
        text: 'Starosna i spolna struktura nastavnika i saradnika u radnom odnosu',
        key: 11,
        value: 11
    },
    {
        text: 'Kadrovska, starosna i spolna struktura stalno zaposlenog nenastavnog osoblja',
        key: 12,
        value: 12
    },
    {
        text: 'Broj zaposlenika u stalnom i dopunskom radnom odnosu po tipu i akademskoj godini',
        key: 13,
        value: 13
    }
];


export default class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: localStorage.getItem('report') ? parseInt(localStorage.getItem('report')) : null,
            orgUnit: null,
            organizationalUnits: [],
            employeeTypes: [],

            academicYears: [],
            academicYear: null,

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeReport = this.closeReport.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchEmployeeTypes()])
            .then(axios.spread((orgUnitsRes, academicYearsRes, employeeTypesRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet');

                const academicYears = academicYearsRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                })).reverse();

                const employeeTypes = employeeTypesRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({
                    employeeTypes: [
                        { key: 'header', text: 'Izvještaj za sve tipove osoblja:', disabled: true },
                        {
                            key: 0, value: 0, text: 'Svi tipovi osoblja', icon: 'clipboard list'
                        },
                        { key: 'header', text: 'Izvještaj razdvojen po tipu osoblja:', disabled: true },
                        ...employeeTypes
                    ],
                    organizationalUnits: [
                        { key: 'header', text: 'Univerzitet:', disabled: true },
                        {
                            key: 0, value: 0, text: 'UNSA', icon: 'university'
                        },
                        { key: 'header', text: 'Članice:', disabled: true },
                        ...organizationalUnits
                    ],
                    academicYears,
                    employeeTypeId: employeeTypesRes.data.find(e => e._key === 'nastavno osoblje').id
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        localStorage.setItem('report', value);
    }

    closeReport() {
        this.setState({ report: null });
        localStorage.removeItem('report');
    }


    render() {
        return (
            <div>
                <Header as="h1">Izvještaji</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"> Spisak izvještaja
                        </Header>
                    </Segment>
                    <Segment secondary={this.state.report !== null}>
                        <Header as="h3">
                            <Form noValidate>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite izvještaj"
                                    value={this.state.report}
                                    onChange={this.handleInputChange}
                                    name="report"
                                    options={reports}
                                    search
                                    fluid
                                    selection
                                />
                            </Form>
                        </Header>
                    </Segment>

                    {localStorage.getItem('report') === '1' &&
                        <Segment clearing>
                            <WorkloadReport
                                closeReport={this.closeReport}
                                academicYears={this.state.academicYears}
                                employeeTypeId={this.state.employeeTypeId}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}

                    {/*{localStorage.getItem('report') === '2' &&*/}
                    {/*    <Segment clearing>*/}
                    {/*        <WorkloadReport*/}
                    {/*            closeReport={this.closeReport}*/}
                    {/*            academicYears={this.state.academicYears}*/}
                    {/*            organizationalUnits={this.state.organizationalUnits}*/}
                    {/*        />*/}
                    {/*    </Segment>}*/}

                    {localStorage.getItem('report') === '3' &&
                        <Segment clearing>
                            <EmployeesByType
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '4' &&
                        <Segment clearing>
                            <EmployeesByAcademicTytle
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}


                    {localStorage.getItem('report') === '5' &&
                        <Segment clearing>
                            <EmployeesByTypeAndGender
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '6' &&
                        <Segment clearing>
                            <EmployeesByTypeAndPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '7' &&
                        <Segment clearing>
                            <EmployeesByTypePositionAndAverageYear
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '8' &&
                        <Segment clearing>
                            <AssociateEmployeesByTypeAndPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}


                    {localStorage.getItem('report') === '9' &&
                        <Segment clearing>
                            <EmployeesWithOUEInfo
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '10' &&
                        <Segment clearing>
                            <EmployeesWithOUPositionInfo
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '11' &&
                        <Segment clearing>
                            <EmployeesGenderAndAgeByPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '12' &&
                        <Segment clearing>
                            <EmployeesGenderAndAgeByEducationLevel
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '13' &&
                        <Segment clearing>
                            <EmployeesByTypeAndAcademicYear
                                closeReport={this.closeReport}
                                academicYears={this.state.academicYears}
                                employeeTypes={this.state.employeeTypes}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/Reports.js